import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Col } from '../../../../../../components/Col';
import CustomIconButton from '../../../../../../components/CustomIconButton/CustomIconButton';
import EvaluationHistoryModal from '../../../../../../components/EvaluationHistoryModal/EvaluationHistoryModal';
import EvaluationModal, {
  APPROVE_ACTION,
  DISAPPROVE_ACTION,
} from '../../../../../../components/EvaluationModal/EvaluationModal';
import ArrowForwardIcon from '../../../../../../components/Icons/ArrowForwardIcon';
import HistoryRoundedIcon from '../../../../../../components/Icons/HistoryRoundedIcon';
import KeyboardArrowUpIcon from '../../../../../../components/Icons/KeyboardArrowUpIcon';
import {
  PROJECT_STATUS_APROVADO,
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_RASCUNHO,
  PROJECT_STATUS_REJEITADO,
} from '../../../../../../library/ProjectStatus';
import { getStepSlug } from '../../../../../../library/ProjectSteps';
import { projectEdit } from '../../../../../../library/Routes';
import { openModal } from '../../../../../../store/modules/ModalActions';
import {
  getDocumentFullPath,
  loadHistoricoAvaliacoes,
} from '../../../../../../store/modules/ProjetoActions';
import { getParsedNewLines } from '../../../../../../utils/HTMLUtils';
import { getProjectFilesByEtapa } from '../../../../../../utils/ProjetoUtils';
import dislikeIcon from './../../../../../../assets/images/svg/dislike-icon.svg';
import likeIcon from './../../../../../../assets/images/svg/like-icon.svg';
import Documento from './Documento';
import styles from './StepRow.scss';
import { Row } from 'components/Row';

const rootClassName = styles.rootClassName;

class StepRow extends Component {
  constructor(props) {
    super(props);

    if (
      !this.props.projeto.historico ||
      !this.props.projeto.historico[this.props.stepIndex]
    ) {
      this.props.loadHistoricoAvaliacoes(
        this.props.projeto.id,
        this.props.stepIndex
      );
    }
  }

  getTitle() {
    switch (this.props.stepIndex) {
      case 0:
        return this.props.languageValues.preCadastro;
      case 1:
        return this.props.languageValues.etapa1;
      case 2:
        return this.props.languageValues.etapa2_1;
      case 3:
        return this.props.languageValues.etapa2_2;
      case 4:
        return this.props.languageValues.etapa3;
      case 5:
        return this.props.languageValues.etapa4;
      case 6:
        return this.props.languageValues.etapa5;
      case 7:
        return this.props.languageValues.etapa6;
      case 8:
        return this.props.languageValues.etapa7;
      case 9:
        return this.props.languageValues.etapa8;
      default:
        return '';
    }
  }

  getStatus() {
    if (
      this.props.projeto.avaliacoes &&
      this.props.projeto.avaliacoes.length &&
      this.props.projeto.avaliacoes[this.props.stepIndex]
    ) {
      return this.props.projeto.avaliacoes[this.props.stepIndex].status;
    }
    return -1;
  }

  getStatusName() {
    if (
      this.props.projeto.avaliacoes &&
      this.props.projeto.avaliacoes.length &&
      this.props.projeto.avaliacoes[this.props.stepIndex]
    ) {
      switch (this.props.projeto.avaliacoes[this.props.stepIndex].status) {
        case PROJECT_STATUS_PENDENTE:
          return ' - ' + this.props.languageValues.projectStatusPendente;
        case PROJECT_STATUS_APROVADO:
          return ' - ' + this.props.languageValues.projectStatusAprovado;
        case PROJECT_STATUS_REJEITADO:
          return ' - ' + this.props.languageValues.projectStatusRejeitado;
        default:
          return '';
      }
    }
    return '';
  }

  getClassNames() {
    const enabled =
      this.props.projeto.avaliacoes.length >= this.props.stepIndex;
    let classes = [rootClassName];
    if (this.props.extended) {
      classes.push(rootClassName + '-extended');
    }
    if (!enabled) {
      classes.push(rootClassName + '-disabled');
    }
    return classes.join(' ');
  }

  getValue(index) {
    const value = this.props.fieldValues[index];
    if (value) {
      if (typeof value === 'string') {
        return getParsedNewLines(value);
      } else {
        return value;
      }
    } else {
      return (
        <i className={rootClassName + '-empty'}>
          {this.props.languageValues.naoPreenchido}
        </i>
      );
    }
  }

  getDocumentos() {
    const documentos = getProjectFilesByEtapa(
      this.props.projeto.documentos,
      this.props.stepIndex,
      this.props.projeto.id
    );
    if (documentos.length > 0) {
      return (
        <Row>
          <Col cols={[12, 12, 12, 12, 12]} className={rootClassName + '-item'}>
            <Row>
              <Col
                cols={[12, 12, 12, 12, 12]}
                className={rootClassName + '-field-name'}
              >
                {this.props.languageValues.etapa9Documentos}
              </Col>
            </Row>
            <Row>
              <Col
                cols={[12, 12, 12, 12, 12]}
                className={rootClassName + '-field-value'}
              >
                {documentos.map((documento, index) => {
                  return (
                    <Documento
                      url={getDocumentFullPath(documento.caminho)}
                      key={index}
                    />
                  );
                })}
              </Col>
            </Row>
          </Col>
        </Row>
      );
    } else {
      return '';
    }
  }

  getContainers() {
    return this.props.fieldNames.map((fieldName, index) => {
      return fieldName ? (
        <Row key={index}>
          <Col cols={[12, 12, 12, 12, 12]} className={rootClassName + '-item'}>
            <Row>
              <Col
                cols={[12, 12, 12, 12, 12]}
                className={rootClassName + '-field-name'}
              >
                {fieldName}
              </Col>
            </Row>
            <Row>
              <Col
                cols={[12, 12, 12, 12, 12]}
                className={rootClassName + '-field-value'}
              >
                {this.getValue(index)}
              </Col>
            </Row>
          </Col>
        </Row>
      ) : null;
    });
  }

  getEtapaButton(enabled) {
    if (enabled) {
      return (
        <button
          className={rootClassName + '-go-to-etapa'}
          onClick={() => {
            this.props.history.push(
              projectEdit.getURLWithParams(
                this.props.projeto.id,
                getStepSlug(this.props.stepIndex)
              )
            );
          }}
        >
          <ArrowForwardIcon />
        </button>
      );
    }
    return '';
  }

  hasHistory() {
    if (
      this.props.projeto.historico &&
      this.props.projeto.historico[this.props.stepIndex] &&
      this.props.projeto.historico[this.props.stepIndex].length > 0
    ) {
      return true;
    }
    return false;
  }

  getActionButtons() {
    return this.props.stepIndex === 0 ? (
      ''
    ) : (
      <div className={rootClassName + '-action-buttons'}>
        {this.props.auth.userPermissions.projetos.approve &&
        !this.props.lockedAllFields ? (
          <CustomIconButton
            tooltip={this.props.languageValues.approveButtonHint}
            className={rootClassName + '-action-button'}
            theme='default'
            icon={likeIcon}
            onClick={() => {
              this.props.openModal(EvaluationModal, {
                action: APPROVE_ACTION,
                stepIndex: this.props.stepIndex,
                title: this.getTitle(),
              });
            }}
          />
        ) : null}
        {this.props.auth.userPermissions.projetos.reprove &&
        !this.props.lockedAllFields ? (
          <CustomIconButton
            tooltip={this.props.languageValues.disapproveButtonHint}
            className={rootClassName + '-action-button'}
            theme='error'
            icon={dislikeIcon}
            onClick={() => {
              this.props.openModal(EvaluationModal, {
                action: DISAPPROVE_ACTION,
                stepIndex: this.props.stepIndex,
                title: this.getTitle(),
              });
            }}
          />
        ) : null}

        <CustomIconButton
          disabled={!this.hasHistory()}
          tooltip={this.props.languageValues.historyButton}
          className={rootClassName + '-action-button'}
          theme='warning'
          icon={<HistoryRoundedIcon />}
          onClick={() => {
            this.props.openModal(EvaluationHistoryModal, {
              stepIndex: this.props.stepIndex,
              title: this.getTitle(),
              history:
                this.props.projeto.historico &&
                this.props.projeto.historico[this.props.stepIndex]
                  ? this.props.projeto.historico[this.props.stepIndex]
                  : [],
            });
          }}
        />
      </div>
    );
  }

  getTitleClassName() {
    let classNames = [rootClassName + '-title'];
    switch (this.getStatus()) {
      case PROJECT_STATUS_PENDENTE:
        classNames.push(rootClassName + '-title-pendente');
        break;
      case PROJECT_STATUS_APROVADO:
        classNames.push(rootClassName + '-title-aprovado');
        break;
      case PROJECT_STATUS_REJEITADO:
        classNames.push(rootClassName + '-title-rejeitado');
        break;
      default:
        break;
    }
    return classNames.join(' ');
  }

  render() {
    if (
      this.props.projeto.avaliacoes.length - 1 < this.props.stepIndex ||
      this.props.projeto.avaliacoes[this.props.stepIndex].status ===
        PROJECT_STATUS_RASCUNHO
    ) {
      return '';
    }
    return (
      <Row className={this.getClassNames()}>
        <Col cols={[12, 12, 12, 12, 12]}>
          <div>
            <button
              className={rootClassName + '-etapa-button'}
              onClick={() => {
                this.props.onExtendChanged(
                  this.props.stepIndex,
                  !this.props.extended
                );
              }}
            >
              <h2 className={this.getTitleClassName()}>
                <KeyboardArrowUpIcon className={rootClassName + '-icon'} />
                {this.getTitle()}
                {this.getStatusName()}
              </h2>
            </button>
            {/* { this.getEtapaButton(enabled) } */}
            <div className={rootClassName + '-container'}>
              {this.getContainers()}
              {this.getDocumentos()}
              {this.getActionButtons()}
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

StepRow.propTypes = {
  stepIndex: PropTypes.number.isRequired,
  onExtendChanged: PropTypes.func.isRequired,
  fieldNames: PropTypes.array.isRequired,
  fieldValues: PropTypes.array.isRequired,
  extended: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadHistoricoAvaliacoes,
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StepRow));
